var QB_FIELD_TYPES = {
  LOAN_VALUES: 'loanValues',
  LTV_VALUES: 'ltvValues',
  SUBJECT_VALUES: 'subjectValues',
  LAST_VALUES: 'lastValues',
  CREDIT_VALUES: 'creditValues'
};
var QB_OPERATOR_TYPES = {
  EQUAL: 'equal',
  NOT_EQUAL: 'notEqual',
  GREATER_THAN: 'greaterThan',
  LESS_THAN: 'lessThan',
  CONTAINS: 'contains',
  NOT_CONTAINS: 'notNontains',
  BETWEEN: 'between',
  GREATER_THAN_OR_EQUAL: 'greaterThanOrEquals',
  LESS_THAN_OR_EQUAL: 'lessThanOrEquals',
  START_WITH: 'startsWith'
};
var QB_GROUP_CONDITION_TYPES = {
  AND: true,
  OR: false
};
var QB_DRAG_TYPES = {
  FILTER: 'filter',
  GROUP: 'group'
};
var QB_DRAG_LOCATIONS = {
  ABOVE: 'above',
  BELOW: 'below'
};
var QB_EXPORT_FORMAT_TYPES = {
  DEFAULT: 'defaultFormat',
  XML: 'xmlFormat',
  SQL: 'sqlFormat',
  SAFESQL: 'sqlSafeFormat'
};
var QB_ADD_FILTER_METHOD_TYPES = {
  IN_PLACE: 'inplace',
  APPEND: 'append'
};
var QB_GROUP_FILTER_METHOD_TYPES = {
  IN_PLACE: 'inplace',
  APPEND: 'append'
};
var QB_FIELD_SHARED_ACTIONS = {
  RESET_FIELD: 'resetField',
  RESET_OPERATOR: 'resetOperator',
  RESET_VALUE: 'resetValue'
};

export { QB_ADD_FILTER_METHOD_TYPES, QB_DRAG_LOCATIONS, QB_DRAG_TYPES, QB_EXPORT_FORMAT_TYPES, QB_FIELD_SHARED_ACTIONS, QB_FIELD_TYPES, QB_GROUP_CONDITION_TYPES, QB_GROUP_FILTER_METHOD_TYPES, QB_OPERATOR_TYPES };
//# sourceMappingURL=types.js.map
